const BOTTOM_PADDING = window.innerWidth < 768 ? 0 : 243;

export { BOTTOM_PADDING };
